// @flow
import weConvertYourFormIcon from 'assets/convert.svg'
import createFromScratchIcon from 'assets/create-from-scratch.svg'
import createSignablePdfIcon from 'assets/signable-pdf.svg'
import chooseTemplateIcon from 'assets/template.svg'
import usePermissions from 'hooks/usePermissions'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Container from 'ui/atoms/Container'
import Flex from 'ui/atoms/Flex'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'

import ButtonBlock from './ButtonBlock'

const Title = styled.h1`
  color: #374151;
  text-align: center;
  margin-bottom: 0;
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 58px;
`

function CreateForm(): React.Node {
  const history = useHistory()

  const { canCreatePacketForm } = usePermissions()

  const handleCreateFromScratch = () => {
    history.push('/forms/new')
  }

  const handleChooseTemplate = () => {
    history.push('/templates')
  }

  const handleCreateSignablePdf = () => {
    history.push('/pdf/new')
  }

  const handleWeConvertYourForm = () => {
    history.push('/forms/convert')
  }

  if (!canCreatePacketForm) return null

  return (
    <Container $marginTop>
      <Flex $flexDirection="col" align="center">
        <Space size="xlarge">
          <Space center size="small">
            <Title>Create a Form</Title>
            <Text>Create or Import a Form to get started</Text>
          </Space>
          <Flex $wrap $flexDirection="row" justify="center">
            <ButtonBlock
              dataCy="create-from-scratch"
              icon={createFromScratchIcon}
              onClick={handleCreateFromScratch}
              subtitle="A clean slate to build and customize."
              title="Create a Form"
            />
            <ButtonBlock
              icon={chooseTemplateIcon}
              onClick={handleChooseTemplate}
              subtitle="Browse our library of pre-made forms."
              title="Choose Template"
            />
            <ButtonBlock
              icon={createSignablePdfIcon}
              onClick={handleCreateSignablePdf}
              subtitle="For PDFs that need to keep their formatting."
              title="Create a Document"
            />
            <ButtonBlock
              icon={weConvertYourFormIcon}
              onClick={handleWeConvertYourForm}
              subtitle="Allow us to convert and design your form."
              title="We Convert your Form"
            />
          </Flex>
        </Space>
      </Flex>
    </Container>
  )
}

export default CreateForm
